import { _Vue } from './index';
import Main from './message.vue';
import { PopupManager } from '../../utils/popup';
import { isVNode } from '../../utils/vdom';
import { isServer } from '../../utils/dom';

import storage from 'good-storage';
const session = storage.session;
let instance;
let instances = [];
let seed = 1;

const SESSION_MESSAGES_PATH_KEY = `__zm_ui_session_msg_${location.pathname}_${location.hash}`;
let el = null;
function createAlertEl() {
  el = document.createElement('p');
  el.setAttribute('role', 'status');
  el.setAttribute('id', 'message-aria-wrap');
  el.className = 'aria-alert-hidden';
  el.style.display = 'block';
  document.body.appendChild(el);
}

function readAria(text) {
  el.innerText = text;
}

const Message = function(options) {
  /* istanbul ignore next */
  if (isServer) return;
  if (!el && !options.delayToReload) {
    createAlertEl();
  }
  options = options || {};
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }
  let userOnClose = options.onClose;
  let id = 'message_' + seed++;

  options.onClose = function() {
    Message.close(id, userOnClose);
    Message.refresh();
    readAria('');
  };
  if (options.delayToReload) {
    delete options.delayToReload;
    const sessionMessages = session.get(SESSION_MESSAGES_PATH_KEY) || [];
    sessionMessages.push(options);
    session.set(SESSION_MESSAGES_PATH_KEY, sessionMessages);
    return;
  }
  let MessageConstructor = _Vue.extend(Main);
  instance = new MessageConstructor({
    data: options
  });
  instance.id = id;
  if (isVNode(instance.message)) {
    instance.$slots.default = [instance.message];
    instance.message = null;
  } else {
    instance.useAriaDialog = false;
  }
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  // delay time can announce successfully by NVDA
  setTimeout(() => {
    readAria(instance.message);
  }, 100);
  let verticalOffset = options.offset || 0;
  instances.forEach(item => {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  verticalOffset += 16;
  instance.verticalOffset = verticalOffset;

  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instance.dom.style.zIndex = 1000 + PopupManager.nextZIndex(!!PopupManager.modalDom);
  instances.push(instance);
  return instance.vm;
};

['success', 'warning', 'info', 'error'].forEach(type => {
  Message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      };
    }
    options.type = type;
    return Message(options);
  };
});

Message.close = function(id, userOnClose) {
  for (let i = 0, len = instances.length; i < len; i++) {
    if (id === instances[i].id) {
      if (typeof userOnClose === 'function') {
        userOnClose(instances[i]);
      }
      instances.splice(i, 1);
      break;
    }
  }
};
Message.refresh = function() {
  for (let i = 0, len = instances.length; i < len; i++) {
    let verticalOffset = 16;
    if (i > 0) {
      verticalOffset = instances[i].verticalOffset - instances[i - 1].$el.offsetHeight - 16;
    }
    instances[i].verticalOffset = verticalOffset;
  }
};

Message.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

export const MessageConstructor = Message;

export const showSessionMessages = function() {
  if (session.get(SESSION_MESSAGES_PATH_KEY)) {
    let sessionMessages = session.get(SESSION_MESSAGES_PATH_KEY);
    if (Array.isArray(sessionMessages) && sessionMessages.length) {
      sessionMessages.forEach(option => {
        setTimeout(() => {
          Message(option);
        }, 0);
      });
      session.remove(SESSION_MESSAGES_PATH_KEY);
    }
  }
};

